import { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { RichTextEditor, StatusMessage } from "components/ui"

const TextEditor = ({
  name,
  onChange,
  richTextEditorRef,
  value = "",
  label = null,
  saveStatus = null,
  destroyAttachmentsOnRemove = false,
  labelRowClasses = "d-f jc-sb ai-c mb-1"
}) => {
  const [status, setStatus] = useState(saveStatus)
  const [inputValue, setInputValue] = useState(value)

  useEffect(() => {
    setStatus(saveStatus)
  }, [saveStatus])

  const clearStatus = () => setTimeout(() => setStatus(null), 6000)

  const handleAttachmentStatus = ({ type, errors }) => {
    if (type === "success") {
      setStatus({
        text: "Saved!",
        icon: "general#check",
        type: "success"
      })
      clearStatus()
    } else if (type === "error") {
      setStatus({
        text: errors || "Changes not saved",
        icon: "general#exclamation-triangle",
        type: "error"
      })
      clearStatus()
    } else if (type === "uploading") {
      setStatus({ text: "Uploading...", icon: "spinner" })
    } else {
      setStatus(null)
    }
  }

  const handleChange = e => {
    setInputValue(e.target.value)
    onChange && onChange(e)
  }

  const trimmedInputValue = inputValue ? inputValue.replace(/[\n\r]/g, "") : ""

  return (
    <div>
      <div className={labelRowClasses}>
        <label htmlFor={name}>{label}</label>
        {status && <StatusMessage {...status} />}
      </div>

      <RichTextEditor
        ref={richTextEditorRef}
        name={name}
        value={trimmedInputValue}
        onChange={handleChange}
        onAttachmentAdd={handleAttachmentStatus}
        destroyAttachmentsOnRemove={destroyAttachmentsOnRemove}
      />
    </div>
  )
}

TextEditor.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  richTextEditorRef: PropTypes.shape({}),
  value: PropTypes.string,
  label: PropTypes.string,
  labelRowClasses: PropTypes.string,
  saveStatus: PropTypes.shape({
    text: PropTypes.string,
    type: PropTypes.string,
    icon: PropTypes.string
  }),
  destroyAttachmentsOnRemove: PropTypes.bool
}

export default TextEditor
